import React, { forwardRef } from 'react';

interface CommentProps {
  classes?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

export const Comment = forwardRef<HTMLElement, CommentProps>(({ classes, style = {}, children }, ref) => {


  return (
    <i ref={ref} className={`fa-regular fa-comment-dots ${classes || ''}`} style={style}>
      {children}
    </i>
  );
});

Comment.displayName = 'Comment';
